import React from "react";
import TravelImage from "../../assets/img/travel-bike.svg";

const HeaderBanner = () => {
  return (
    <section className="header-banner">
      <div className="container">
        <div className="header-banner__column">
          <h2 className="heading--primary">
            Business rules engine that streamlines your business workflow
          </h2>
          <p className="text--primary">
            DecisionRules helps you speed up everyday decision making processes
            in e-commerce, logistics, health, financial industry, and more
          </p>
          <div className="header-banner__buttons">
            <a
              href="https://app.decisionrules.io/auth/register?type=true-registration"
              className="cta cta--primary"
            >
              Try DecisionRules
            </a>
            <a
              href="https://www.decisionrules.io/?modal=demo"
              className="cta cta--secondary"
            >
              Book a demo
            </a>
          </div>
        </div>
        <div className="header-banner__column">
          <img
            src={TravelImage}
            alt="Travel"
            className="header-banner__image"
          />
        </div>
      </div>
    </section>
  );
};

export default HeaderBanner;
